var Clear = "Clear";
var EN_TRANSLATION = {
  Clear: Clear,
  "Log In": "Log In",
  "Manage Account": "Manage Account",
  "Order History": "Order History",
  "Privacy policy": "Privacy policy",
  "Show Me": "Show Me",
  "Sign Out": "Sign Out",
  "Sign Up": "Sign Up",
  "Terms and Conditions": "Terms and Conditions",
  "UI Account": "UI Account",
  "UniFi Site Manager": "UniFi Site Manager"
};
export { Clear, EN_TRANSLATION as default };
//# sourceMappingURL=en.json.mjs.map
